import { render, staticRenderFns } from "./HospitalInfo.vue?vue&type=template&id=4eea80e4&"
import script from "./HospitalInfo.vue?vue&type=script&lang=js&"
export * from "./HospitalInfo.vue?vue&type=script&lang=js&"
import style0 from "./HospitalInfo.vue?vue&type=style&index=0&id=4eea80e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports